import { motion } from "framer-motion";

const INCLUYE = [
  "Diseño web editorial y personalizado.",
  "Optimizada para móvil, tablet y ordenador.",
  "Preparada para captar contactos y solicitudes.",
  "Configuración SEO inicial.",
  "Integración con WhatsApp, formularios y Google Maps cuando sea necesario.",
  "Publicación y configuración del dominio.",
  "Animaciones e interacciones premium.",
  "Introducción cinematográfica personalizada.",
  "5 pequeñas mejoras durante los primeros 30 días tras el lanzamiento.",
];

const COMPLEMENTARIOS = [
  "Ghostwriting para blogs y publicaciones.",
  "Redacción de nuevas páginas web.",
  "Landing pages para campañas específicas.",
  "Evolución y mejoras continuas de tu web.",
];

function Check() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="shrink-0 mt-[3px]" aria-hidden="true">
      <path d="M3 8.5l3.2 3.2L13 4.8" stroke="#FF6B2C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function scrollToContact() {
  const el = document.getElementById("contact");
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -40, duration: 1.4 });
  else el?.scrollIntoView({ behavior: "smooth" });
}

export default function Pricing() {
  return (
    <section id="pricing" data-testid="pricing-section" className="relative py-16 lg:py-24">
      <div className="max-w-[95%] mx-auto">
        <div className="mb-10 lg:mb-16">
          <div className="font-sans text-[11px] tracking-[0.24em] uppercase text-[color:var(--ink-60)] mb-5">
            — Tarifas · Índice 005
          </div>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tightest max-w-3xl pb-2">
            Todo lo <span className="font-italic-display">necesario.</span>
          </h2>
        </div>

        {/* Single plan */}
        <motion.div
          data-testid="pricing-card"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
          className="relative border p-8 lg:p-14 overflow-hidden"
          style={{ background: "#111111", color: "#FAF8F5", borderColor: "#111111" }}
        >
          <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full opacity-30 blur-3xl pointer-events-none" style={{ background: "#FF6B2C" }} />

          <div className="relative grid lg:grid-cols-12 gap-10 lg:gap-16">
            {/* Price */}
            <div className="lg:col-span-5">
              <div className="flex items-baseline gap-3">
                <span className="font-display text-[18vw] lg:text-[8vw] leading-[0.85] tightest pb-2">699</span>
                <span className="font-display text-3xl lg:text-4xl leading-none opacity-70">€</span>
              </div>
              <div className="mt-2 font-sans text-[12px] tracking-[0.2em] uppercase opacity-60">IVA incluido</div>
              <p className="mt-6 max-w-sm font-sans text-base leading-relaxed opacity-80">
                Un proyecto, cerrado y sin sorpresas. Una web de la que te sentirás orgulloso de compartir.
              </p>
              <button
                data-testid="pricing-cta"
                onClick={scrollToContact}
                className="btn-primary mt-8"
                style={{ background: "#FF6B2C", borderColor: "#FF6B2C", color: "#111111" }}
              >
                Comenzar el proyecto
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M1 7h12M8 2l5 5-5 5" stroke="currentColor" strokeWidth="1.6" fill="none" /></svg>
              </button>
            </div>

            {/* Includes */}
            <div className="lg:col-span-7">
              <div className="font-sans text-[11px] tracking-[0.22em] uppercase opacity-60 mb-6">Incluye</div>
              <ul className="grid grid-cols-1 gap-y-3">
                {INCLUYE.map((f) => (
                  <li key={f} className="flex items-start gap-3 border-b border-white/10 pb-3 font-sans text-sm leading-snug">
                    <Check />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Complementary services */}
        <div className="mt-16 lg:mt-24 grid lg:grid-cols-12 gap-8 lg:gap-16">
          <div className="lg:col-span-4">
            <h3 className="font-display text-3xl lg:text-4xl leading-[1.05] tighter pb-1">
              También podemos <span className="font-italic-display">ayudarte con…</span>
            </h3>
          </div>
          <div className="lg:col-span-8">
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-4">
              {COMPLEMENTARIOS.map((s) => (
                <li key={s} className="flex items-start gap-3 border-t border-[color:var(--ink-10)] pt-4 font-sans text-base leading-snug text-[color:var(--ink)]/85">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full shrink-0" style={{ background: "#FF6B2C" }} />
                  {s}
                </li>
              ))}
            </ul>
            <p className="mt-8 font-sans text-base leading-relaxed text-[color:var(--ink-60)] max-w-xl">
              Si tienes una idea diferente, cuéntanosla. Nos encantan los proyectos especiales.
            </p>
          </div>
        </div>

        {/* Post-support */}
        <div className="mt-16 lg:mt-24 border-t border-[color:var(--ink-10)] pt-10 grid lg:grid-cols-12 gap-8 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="font-sans text-[11px] tracking-[0.22em] uppercase text-[color:var(--ink-60)]">Acompañamiento posterior</div>
          </div>
          <div className="lg:col-span-8">
            <p className="font-display text-2xl lg:text-3xl leading-snug tighter pb-1 max-w-2xl">
              Si tu proyecto evoluciona, tu web también puede hacerlo. Cualquier mejora, ampliación o nueva funcionalidad se valorará de forma individual. Presupuesto por convenir.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
